import styled, { css } from 'styled-components';
import { getIconUrl, pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
// TODO Update when design updates gaps between Figma and FE
const CHEVRON_SIZE = 7.2;
const HEIGHT_MOBILE = 35;
const HEIGHT_DESKTOP = 70;
/**
 * BreadcrumbContainer
 */
export const breadcrumbContainerStyles = ({ theme }) => css `
	display: flex;
	align-items: flex-end;
	height: ${HEIGHT_MOBILE}px;
	background: ${theme.colors.gradients.bgBreadcrumb};
	padding: ${pxToRem(theme.spacing['200'])};

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		height: ${HEIGHT_DESKTOP}px;
		padding: 0 ${pxToRem(theme.spacing['500'])} ${pxToRem(theme.spacing['300'])}
			${pxToRem(theme.spacing['500'])};
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		height: ${HEIGHT_DESKTOP}px;
		padding: 0 0 ${pxToRem(theme.spacing['300'])} ${pxToRem(theme.spacing['500'])};
	}
`;
export const BreadcrumbContainer = styled.nav `
	${breadcrumbContainerStyles}
`;
/**
 * Breadcrumb List
 */
export const breadcrumbListStyles = ({ theme }) => css `
	display: flex;
	align-items: center;
	gap: ${pxToRem(theme.spacing['100'])};
	list-style: none;
	margin: 0;
	padding: 0;
`;
export const BreadcrumbList = styled.ol `
	${breadcrumbListStyles}
`;
/**
 * Breadcrumb List Item
 */
export const breadcrumbListItemStyles = ({ theme }) => css `
	display: none;

	&:last-child {
		display: inline-block;
		width: 100%;

		${BreadcrumbLink}:before {
			margin-right: ${pxToRem(theme.spacing['100'])};
			content: '';
			mask: url('${getIconUrl('chevron-left', 'ui')}') no-repeat center right;
			background-color: ${theme.colors.medium.textBreadcrumb};
			height: ${pxToRem(CHEVRON_SIZE)};
			width: ${pxToRem(CHEVRON_SIZE)};
		}
	}

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
		display: inline-block;

		&:last-child {
			width: auto;
		}

		${BreadcrumbLink}:before {
			display: none;
		}

		&:not(:last-child) ${BreadcrumbLink}:after {
			content: '';
			mask: url('${getIconUrl('chevron-right', 'ui')}') no-repeat center right;
			background-color: ${theme.colors.medium.textBreadcrumb};
			height: ${pxToRem(CHEVRON_SIZE)};
			width: ${pxToRem(CHEVRON_SIZE)};
			margin-left: ${pxToRem(theme.spacing['100'])};
		}
	}
`;
export const BreadcrumbListItem = styled.li `
	${breadcrumbListItemStyles}
`;
/**
 * Breadcrumb Link
 */
export const breadcrumbLinkStyles = () => css `
	align-items: center;
	display: flex;
	overflow: hidden;
	white-space: nowrap;
`;
export const BreadcrumbLink = styled(Typography) `
	${breadcrumbLinkStyles}
`;
//# sourceMappingURL=breadcrumb.styled.js.map